const languages = () => ({
  es: { name: 'Español' },
  // en: { name: 'English' },
  // fr: { name: 'Français' },
  // jhipster-needle-i18n-language-key-pipe -  Enhouse billing will add/remove languages in this object
});

export default languages;
